import { Causes } from '@platform/client';
import { MultiSelectDropdown } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';

type CauseSelectionDropdownProps = {
  selectionLimit?: number;
  selectedCauses: string[];
  onCausesSelectionChange: (selectedCauses: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  placeholder?: string;
  label: string;
};

export const CauseSelectionDropdown = (props: CauseSelectionDropdownProps) => {
  const {
    selectionLimit,
    selectedCauses,
    onCausesSelectionChange,
    register,
    errors,
    placeholder,
    label,
  } = props;

  const causesList = Causes.useGetCauses();

  const causeOptions =
    causesList.isSuccess ?
      causesList.data.map((cause) => ({
        label: cause.shortName,
        value: cause.name,
        description: cause.shortDescription,
      }))
    : [];

  return (
    <div className='w-[350px]'>
      <MultiSelectDropdown
        register={register}
        selectedItems={selectedCauses}
        onSelectionChange={onCausesSelectionChange}
        options={causeOptions}
        selectionLimit={selectionLimit}
        label={label}
        error={errors?.causes?.message}
        filterable={true}
        placeholder={placeholder || 'Select causes'}
      />
    </div>
  );
};
